// oxlint-disable-next-line import/named
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;
